// src/lib/supabase.ts
import { createClient, type User } from "@supabase/supabase-js";
import { ENV } from "./env";

// Safe, singleton browser client for Supabase
let _client:
  | ReturnType<typeof createClient<{ [key: string]: any }>>
  | null = null;

export function getSupabase() {
  if (!ENV.SUPABASE_URL || !ENV.SUPABASE_ANON) return null;
  if (_client) return _client;
  _client = createClient(ENV.SUPABASE_URL, ENV.SUPABASE_ANON, {
    auth: {
      detectSessionInUrl: true,
      persistSession: true,
      autoRefreshToken: true,
    },
  });
  return _client;
}

// ——————————————————————————————————
// EXPORT THE INSTANCE AS `supabase`
// ——————————————————————————————————
export const supabase = getSupabase();

// ——————————————————————————————————
// AUTH HELPERS
// ——————————————————————————————————
export async function currentUser(): Promise<User | null> {
  const supa = getSupabase();
  if (!supa) return null;
  const { data, error } = await supa.auth.getUser();
  if (error) return null;
  return data.user ?? null;
}

export async function signOut(): Promise<void> {
  const supa = getSupabase();
  if (!supa) return;
  await supa.auth.signOut();
}

// ——————————————————————————————————
// EXPORT createClient FOR ONBOARDING
// ——————————————————————————————————
export { createClient };
